import React, { useMemo, useRef, useState, useEffect } from "react";
import { Tag, Carousel, Tooltip } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import { PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import AssignBadge from "./AssignBadge";

const ChatBadges = ({ showTag, itemId, badges, allBadges, onAssignBadge,report,setList }) => {
  const carouselRef = useRef(null);
  const [badgeData, setBadgeData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  // Initialize badgeData with badges prop
  useEffect(() => {
    if (badges && Array.isArray(badges)) {
      setBadgeData(badges);
    } else {
      setBadgeData([]);
    }
  }, [badges]);
  
  // Calculate this after badgeData is set
  const slidesToShow = Math.min(4, badgeData?.length || 0);
  
  const badgeColors = useMemo(() => [
    "#a83271",
    "#f6b317",
    "#b18150",
    "#8b2a42",
    "#97b928",
    "#f4456c",
    "#1ab8dc",
    "#62c9a6"
  ], []);
  
  const getRandomColor = (index) => {
    // Use tag index to pick a color or fallback to random if index is out of bounds
    return badgeColors[index % badgeColors.length] || 
           badgeColors[Math.floor(Math.random() * badgeColors?.length)];
  };
  
  const handleShowBadge = () => {
    setIsModalVisible(true);
  };
  
  const handleCloseBadge = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <AssignBadge
         visible={isModalVisible}
         badgeData={badgeData}
         allBadges={allBadges}
         reportId={itemId}
         report={report}
         setList={setList}
         onAssignBadge={onAssignBadge}
         setShow={setIsModalVisible}
         onClose={handleCloseBadge}
         HandleShowBadge={handleCloseBadge}
         getRandomColor={getRandomColor}
      />
      {showTag && showTag[itemId] && (
        <motion.div
          className="tags-carousel-container d-flex gap-2"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          style={{ position: "relative", maxWidth: "60%" }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{ position: "relative", maxWidth: "95%", minWidth: "150px" }}
          >
            {badgeData?.length > 0 ? (
              <Carousel
                ref={carouselRef}
                dots={false}
                slidesToShow={slidesToShow}
                slidesToScroll={1}
                swipeToSlide={true}
                draggable
                adaptiveHeight
                infinite={false}
                className="tags-carousel"
                variableWidth={badgeData?.length <= 2}
                centerMode={badgeData?.length <= 2}
                centerPadding="0px"
              >
                {badgeData.map((tag, idx) => (
                  <div key={`tag-${itemId}-${tag.id || idx}`} className="tag-item">
                    <Tooltip title={tag?.title} placement="top">
                      <Tag
                        color={tag?.color || getRandomColor(idx)}
                        style={{
                          margin: "0 4px",
                          lineHeight: "1.5",
                          display: "inline-block",
                          whiteSpace: "nowrap",
                          padding: "2px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          maxWidth: "90%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {tag?.title}
                      </Tag>
                    </Tooltip>
                  </div>
                ))}
              </Carousel>
            ) : (
              <div className="p-1">No badges assigned</div>
            )}
          </div>
          <Link onClick={handleShowBadge}>
            <Tag className="rounded-circle d-flex justify-content-center align-items-center p-1">
              <PlusOutlined style={{ fontSize: "14px" }} />
            </Tag>
          </Link>
        </motion.div>
      )}
    </>
  );
};

export default ChatBadges;